//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "auditing-score-detail",
  data() {
    return {
      ratingId: null,
      scoringId: null,
      planObj: {},
      scoreObj: {},
      scoreList: [],
      scoreFields:{},
      viewPeople:{},
      index:0,
      audited:false
    }
  },
  methods: {
    //获取评分数据
    getRatingDto() {
      this.$loadingShow();
      this.$get(`api/scoring-scheme-detail/${this.ratingId}`).then((data) => {
        if (data) {
          this.planObj = data;
          if (this.planObj.dynamicForm && this.planObj.dynamicForm.dynamicTables && this.planObj.dynamicForm.dynamicTables[0] && this.planObj.dynamicForm.dynamicTables[0].dynamicFields) {
            this.planObj.dynamicForm.dynamicTables[0].dynamicFields.forEach((field) => {
              if (field.config) {
                let config = JSON.parse(field.config);
                let rule = '';
                if (config.rules) {
                  config.rules.forEach((str) => {
                    rule += str;
                  })
                }
                field.ruleStr = rule;
                field.maxScore = config.maxScore;
                field.minScore = config.minScore;
              }
            })
          }
          this.getSupScore();
        }
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      });
    },
    //  获取供应商得分
    getSupScore() {
      this.$get(`api/scoring-value/${this.scoringId}/-1/current`).then((data) => {
        this.scoreObj = data;
        if (this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName]) {
          this.scoreList = this.scoreObj.data[this.planObj.dynamicForm.dynamicTables[0].tableName];
          for(let i=0;i<this.scoreList.length;i++){
            if(this.scoreList[i].person === 'AVERAGE_SCORE'){
              this.scoreFields = this.scoreList[i];
              break;
            }
          }
        }
      });
    },
    changeShow(item){
      if(item.cellShow){
        this.$set(item,'cellShow',false);
        return;
      }
      this.$set(item,'cellShow',true);
    },
    changePeople(item){
      let peopleId;
      if(item === 'AVERAGE_SCORE'){
        peopleId = 'AVERAGE_SCORE';
        this.viewPeople = {};
      }else{
        if(this.planObj.scoringPersonType === 'PERSON'){
          peopleId = item.scoringPerson.person.id;
        }else if(this.planObj.scoringPersonType === 'EXPERT'){
          peopleId = item.scoringPerson.expert.personDto.id;
        }
        this.viewPeople = item;
      }
      this.scoreFields = {};
      for(let i=0;i<this.scoreList.length;i++){
        if(this.scoreList[i].person == peopleId){
          this.scoreFields = this.scoreList[i];
          break;
        }
      }
    },
    againScore(){
      this.$loadingShow();
      this.$get(`api/scoring-value/re-scoring/${this.viewPeople.id}`).then((res) => {
        this.$loadingHide();
        if(res.status){
          this.$vux.toast.text('操作成功');
          this.viewPeople = {};
          this.index = 0;
          this.getRatingDto();
        }
      }).catch(() => {
        this.$loadingHide();
      })
    },
    cancelScoring(){
      this.$loadingShow();
      this.$get(`api/scoring-value/cancel-scoring/${this.viewPeople.id}`).then((res) => {
        this.$loadingHide();
        if(res.status){
          this.$vux.toast.text('操作成功');
          this.viewPeople = {};
          this.index = 0;
          this.getRatingDto();
        }
      }).catch(() => {
        this.$loadingHide();
      })
    }
  },
  mounted() {
    this.ratingId = this.$route.params.ratingId;
    this.scoringId = this.$route.params.supId;
    if(this.$route.query.audited){
      this.audited = this.$route.query.audited;
    }
    this.getRatingDto();
  }
}



// WEBPACK FOOTER //
// ./src/page/sources/source-score/auditing-score-detail.vue